import * as React from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function ManualAddTickets({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 20 20" width={size} {...props}>
      <G clipPath="url(#clip0_2772_483)">
        <Path
          d="M16.06 7C16.1813 6.40658 16.4791 5.86367 16.9144 5.44251C17.3497 5.02135 17.9021 4.74162 18.4992 4.64C18.639 4.61672 18.7661 4.54463 18.8578 4.43654C18.9494 4.32844 18.9998 4.19134 19 4.0496V2.2C19 1.88174 18.8736 1.57652 18.6485 1.35147C18.4235 1.12643 18.1183 1 17.8 1H2.2C1.88174 1 1.57652 1.12643 1.35147 1.35147C1.12643 1.57652 1 1.88174 1 2.2V4.0512C0.999836 4.19303 1.05012 4.3303 1.14187 4.43846C1.23362 4.54662 1.36084 4.61863 1.5008 4.6416C2.20151 4.75834 2.83808 5.11988 3.29726 5.66189C3.75644 6.2039 4.00845 6.89123 4.00845 7.6016C4.00845 8.31197 3.75644 8.9993 3.29726 9.54131C2.83808 10.0833 2.20151 10.4449 1.5008 10.5616C1.36091 10.5851 1.23386 10.6573 1.14218 10.7655C1.0505 10.8738 1.00013 11.011 1 11.1528V13C1 13.3183 1.12643 13.6235 1.35147 13.8485C1.57652 14.0736 1.88174 14.2 2.2 14.2H7"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M7 11.8V10.6"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M7 8.20006V7.00006"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M7 4.59996V3.39996"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M9.40002 14.2C9.40002 15.4731 9.90574 16.694 10.8059 17.5941C11.7061 18.4943 12.927 19 14.2 19C15.4731 19 16.694 18.4943 17.5941 17.5941C18.4943 16.694 19 15.4731 19 14.2C19 12.927 18.4943 11.7061 17.5941 10.8059C16.694 9.90574 15.4731 9.40002 14.2 9.40002C12.927 9.40002 11.7061 9.90574 10.8059 10.8059C9.90574 11.7061 9.40002 12.927 9.40002 14.2Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M14.2 11.8V16.6"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M11.8 14.2H16.6"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2772_483">
          <Rect fill="white" height="20" width="20" />
        </ClipPath>
      </Defs>
    </Svg>
  );
});
